import yup from "../utility/ValidationUtilty";

export type PhoneContact = {
  id: string;
  enableFlag: boolean;
  phoneNo: string;
  staffName: string;
  dayOfWeek: string[];
  onCallStartTime: string;
  onCallEndTime: string;
  createUser: string;
  createAt: Date;
  updateAt?: Date;
};

// firestoreから取得したデータのマッピング
export const PhoneContactTimestampToDate = (data: any | undefined): PhoneContact => {
  data.createAt = new Date(data?.createAt.seconds * 1000);
  if(data.updateAt !== undefined){
    data.updateAt = new Date(data?.updateAt.seconds * 1000);
  }
  return data;
};
const phoneRegExp = /^0[-\d]{11,12}$/;
export const phoneContactSchema = yup.object({
  // 担当者名
  staffName: yup.string().required(),
  // 問い合わせ先番号
  phoneNo: yup.string().matches(phoneRegExp, '電話番号の形式で数字と-のみで入力してください。').required(),
  // 発信可能曜日
  dayOfWeek: yup.array().test((value, context) => {
    if (value !== undefined) {
      const result = value.indexOf('1');
      if (result === -1) {
        /* 配列内に'1'が見つからなかった場合 */
        return context.createError({
          message: '必ず入力してください。'
        })
      }
    }
    return true;
  }).required(),
  // 開始時間
  onCallStartTime: yup.string().required(),
  // 終了時間
  onCallEndTime: yup.string().required(),
});
